<template>
    <ies-form-field :field="field">
        <v-layout row wrap>
            <v-col cols="3">
                <v-btn v-on:click="chooseOperator" 
                       v-show="!shouldShowPicker">{{ buttonLabel }}</v-btn>
                <v-btn v-on:click="clearOperator" 
                       v-show="selectedOperator">Clear</v-btn>
            </v-col>

            <v-col cols="10" v-if="shouldShowPicker">
                <v-container>
                    <v-layout row wrap>
 
                        <v-col cols="2">Travel Operator: </v-col>
                        <v-col cols="10">
                            <v-text-field hide-details
                                v-model="operatorViewName" 
                                v-on:keyup="updateOperatorName()"
                             ></v-text-field>
                         </v-col>

                         <v-col cols="12" v-if="operatorOptions.length">
                                 <ul>
                                     <li v-for="operator in operatorOptions" v-on:click="selectOperator(operator.user_key)">({{ operator.username }}) {{ operator.first_name }} {{ operator.surname }}</li>
                                 </ul>
                         </v-col>

                          <v-col cols="12">
                              <v-btn v-on:click="done">Done</v-btn>
                          </v-col>

                   </v-layout>
               </v-container>
           </v-col>

           <input type="hidden" :name="field.fieldName" :value="field.value">


        </v-layout>
    </ies-form-field>
</template>

<script>
    /**
     * Allows the selection of an operator ID by choosing its name or code from
     * a selection downloaded from the API on creation
     *
     * @todo refactor, make more efficient
     */
    export default {
        name: 'ies-input-travel-operator-key',
        props: ['field', 'configuration'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                /** string view model */
                operatorViewName: '',

                /** array of operator options presented to the user */
                operatorOptions: [],

                /** data model of all supported operators */
                operators: [],

                /** view model to determine whether the hotel  picker should display */
                shouldShowPicker: false,

                /** The operator chosen by the user */
                viewValue: parseInt(this.field.value),

                selectedOperator: null,

                /** For where the component is used in event mode to talk to other components */
                config: {'shouldEmitOnSelect': false, 'selectEventName': ''}
            }
        },
        created:function() {
            this.getOperators();

            if (this.configuration){
                var config = JSON.parse(this.configuration);
                console.log(config);
                if (config.shouldEmitOnSelect && config.selectEventName){
                    this.config.shouldEmitOnSelect = config.shouldEmitOnSelect;
                    this.config.selectEventName = config.selectEventName;
                }
            }
        },
        methods: {
            getOperators:function(){
                var self = this;
                axios.get('/api/travelOperators')
                .then(function(response){
                    this.operators = response.data.travelOperators;
                    this.operators.forEach(function(operator){
                        if (operator.user_key == self.field.value){
                            self.selectedOperator = operator;

                            // Set the view models so that it is reflected to the users
                            self.operatorViewName = operator.username;
                        }
                    });
                }.bind(this));
            },

            updateOperatorName: function(){
                var self = this;
 
                var operatorOptions = [];
                this.operators.forEach(function(operator){
                    let fullname = operator.first_name + ' ' + operator.surname;
                    if (operator.username.toLowerCase().includes(self.operatorViewName.toLowerCase()) || fullname.toLowerCase().includes(self.operatorViewName.toLowerCase())){
                        operatorOptions.push(operator);
                    }
                });
                this.operatorOptions = operatorOptions;

                // If there is only one hotel left in the list of options then we select it
                if (this.operatorOptions.length === 1){
                    this.selectedOperator = this.operatorOptions[0];
                    this.updateFieldValue();
                }
            },

            selectOperator: function(operatorKey){
                var self = this;
                this.operators.forEach(function(operator){
                    if (operator.user_key === operatorKey){
                        self.selectedOperator = operator;
                        self.operatorViewName = operator.first_name + ' ' + operator.surname;
                        self.updateFieldValue();
                    }
                });
            },

            chooseOperator: function(){
                this.shouldShowPicker = true;
            },

            clearOperator: function(){
                this.selectedOperator = null;
                this.operatorViewName = '';
                this.field.value = null;

                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {value: null});
                }
            },

            done: function(){
                this.shouldShowPicker = false;
            },

            updateFieldValue: function(){
                this.field.value = this.selectedOperator.user_key;

                console.log("updatefieldvalue on select: ", this.config);
                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {value: this.field.value});
                }
            }
        },
        watch: {
            viewValue: function (newValue) {
            }
        },
        computed: {
            buttonLabel: function(){
                return this.selectedOperator ? "(" + this.selectedOperator.username + ") " + this.selectedOperator.first_name + ' ' + this.selectedOperator.surname : "Choose";
            }
        }

    }
</script>


